import {
  ActionClear,
  ActionSetError,
  ActionSetInfo,
  ActionSetLoading,
  ActionSetOK,
  ActionTypesGlobalNotifs,
} from "./actionTypes";

export const setOk = (payload: ActionSetOK["payload"]): ActionSetOK => {
  return {
    type: ActionTypesGlobalNotifs.SET_OK,
    payload,
  };
};

export const setInfo = (payload: ActionSetInfo["payload"]): ActionSetInfo => {
  return {
    type: ActionTypesGlobalNotifs.SET_INFO,
    payload,
  };
};

export const setError = (
  payload: ActionSetError["payload"]
): ActionSetError => {
  return {
    type: ActionTypesGlobalNotifs.SET_ERROR,
    payload,
  };
};

export const setLoading = (
  payload: ActionSetLoading["payload"]
): ActionSetLoading => {
  return {
    type: ActionTypesGlobalNotifs.SET_LOADING,
    payload,
  };
};

export const notifsClear = (): ActionClear => {
  return {
    type: ActionTypesGlobalNotifs.CLEAR,
  };
};
